export const IPG_PAYMENT_FORM_TEST_ID = {
  root: 'ipg-payment-form'
};
